import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-auction-end-count-down',
  templateUrl: './auction-end-count-down.component.html',
  styleUrls: ['./auction-end-count-down.component.css']
})
export class AuctionEndCountDownComponent implements OnInit {
  color: ThemePalette = 'warn';
  mode: ProgressSpinnerMode = 'determinate';
  value: number = 100;
  @Input() TimerMode: 'seconds' | 'minute' = 'seconds';
  // @Input() timer: any;


  @Input() countDown: any = 90;
  @Input() currentPercent: any;

  // @Input() strokeWidth: any;
  // @Output() TimerEnded = new EventEmitter<boolean>();
  // currentTimer: number = 0;


    

  // @Input() TotalTime: any
  // @Input() RemainingTime: any

  // currentPercent: number = 100
  // titleNumber: number = 60;
  // title: string = '60'

  constructor() { }

  ngOnInit() {

    //this.Timer();


  }

  ngOnChanges(changes: any): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    
    // console.log(changes);
    // if (changes.RemainingTime.currentValue > 0) {
    
    //   this.currentPercent = 100;
      
    //   this.Timer();
    // }

  }



  startDate: any = Date.now() - (15 * 1000); // current time minus 15 seconds
  duration: any = 60 * 1000; // 1 minute


  onDestroyInterval() {

  }

  onTimerComplete(): void {
    console.log('timer completed!');
  }

  // Timer() {
  //   this.currentTimer = this.RemainingTime
  //   this.title = this.RemainingTime;
  //   this.titleNumber = parseInt(this.RemainingTime);
  //   this.currentPercent = (100 / this.TotalTime) * this.RemainingTime
  
  //   if (this.TimerMode === 'seconds') {
  //     let x = setInterval(() => {
  //       // if (this.value <= 0) {
  //       //   this.TimerEnded.emit(true)
  //       //   console.log("Timer Has Stopped");
  //       //   clearInterval(x)
  //       // }
  //       // else {
  //       //   this.value -= (100 / this.timer) / 100
  //       //   this.currentTimer -= 0.01
  //       // }

  //       this.currentPercent -= ((100 / this.TotalTime) / 100)/2
  //       this.titleNumber -= 0.01/2
  //       this.title = Math.ceil(this.titleNumber).toString()
  //       if (this.titleNumber <= 0) {
  //         // this.RemainingTime = 0;
  //         this.TimerEnded.emit(true);
  //         clearInterval(x);

  //       }
  //     }, 10)
     
  //   } else if (this.TimerMode === 'minute') {
  //     let x = setInterval(() => {
  //       this.currentPercent -= ((100 / this.TotalTime) / 60)
  //       this.titleNumber -= (1 / 60)
  //       this.title = Math.ceil(this.titleNumber).toString()
  //       if (this.titleNumber <= 0) {
  //         // this.RemainingTime = 0;
  //         this.TimerEnded.emit(true)
  //         clearInterval(x);
  //       }
  //     }, 1000)
  //   }

  // }

}
